<template>

    <div>

        <loading-indicator v-if="logsLoading"></loading-indicator>

        <div class="logsContainer" v-else-if="logs.length > 0">


            <div class="columns">

                <div class="column">

                    <timeline>

                        <timeline-item v-for="(entry, index) in logs" :key="index" :date="entry.loggedAt | formatDate" type="primary" :icon="getIcon(entry.action)">

                            <span class="author">
                                <template v-if="entry.username">{{ entry.username }}</template><template v-else>{{ entry.user.username }}</template>:
                            </span>

                            <!-- <lang :labelKey="'LOG-'+entry.action"></lang> -->
                            <lang :labelKey="getEventDescription(entry)" :labelKey2="entry.label"></lang>

                        </timeline-item>

                    </timeline>

                </div>
            </div>


        </div>

        <div v-else>

            <div class="column is-offset-0">
                <alert :animated="false" icon="info-circle" :closable="false">
                    Für diesen Bereich liegen noch keine Logdaten vor ...
                </alert>
            </div>

        </div>
    </div>
</template>


<script>
export default {

    props: {
        history: {
            type: Array,
            default: function() { return [] },
            required: true
        },
        logsApi: {
            type: String,
            default: null,
            required: false
        }
    },

    data() {

        return {
            logs: null,
            logsLoading: false
        }

    },

    created() {

        this.logsLoading = true;

        if(this.logsApi != null) {

            this.axios.get(this.$config.api + this.logsApi).then(res => {

                this.logs = res.data.logEntry;
                this.logsLoading = false;

            })

        } else {

            this.logs = this.history;
            this.logsLoading = false;

        }


    },


    methods: {

        getIcon(action) {

            let icon = "";

            switch(action) {
                case "create": icon = "plus"; break;
                case "update": icon = "pencil"; break;
                case "remove": icon = "trash-o"; break;
                case "upload": icon = "upload"; break;
                case "email": icon = "envelope-o"; break;
            }

            return icon;

        },

        getEventDescription(row) {

            let valueLabel = row.valueLabel != 'null' && row.valueLabel != null
                ? this.$t(row.valueLabel)
                : JSON.parse(row.value);

            return this.$t(row.label, { OBJECT_NAME: '<strong>'+row.objectName+'</strong>', VALUE: '<strong>'+valueLabel+'</strong>' });

        }
    }

}
</script>


<style>

    .timeline-item:before {
        top: 5px;
    }
    .logsContainer {
        padding: 0 25px;
        height: 50vh;
        overflow-y: auto;
        overflow-x: hidden;
    }
    .logsContainer .author {
        width: 150px;
        display: inline-block;
        float: left;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        padding-right: 10px;
    }
    .timeline-item span:nth-child(2) {
        white-space: pre-line;
        display: block;
        margin-left: 150px;
    }

    .timeline-item.is-primary .timeline-icon {
        background-color: #eaeaea;
        color: #000 !important;
        width: 24px;
        height: 24px;
        display: flex;
        justify-content: center;
        align-items: center;
        top: 4px;
        left: -12px;
    }
    .timeline-item .timeline-icon i {
        margin: 0;
    }
</style>

<style scoped>
    .columns {
        margin: 0;
    }
</style>
